import React from 'react';
import { CircleAlert } from 'lucide-react';
import { useFormContext } from 'react-hook-form';
import { UserConfigInputs } from '../model/user-config.types';

const UserAdjustConfigFields: React.FC = () => {
    const { register } = useFormContext<UserConfigInputs>();
    return (
        <div className="col-6">
            {/* 비노출시 경쟁 */}
            <div className="d-flex gap-3 mb-2">
                <div className="form-check form-switch">
                    <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        {...register('adjust_no_exposed.is_enabled')}
                    />
                    <label className="form-label">가격비교에 내 상품 비노출 시에도 가격조정</label>
                </div>
            </div>

            {/* 가격비교 할인율 */}
            <div className="d-flex gap-3">
                <div className="form-check form-switch">
                    <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        {...register('skip_low_coupon.is_enabled')}
                    />
                    <label className="form-label">쿠폰율에 따른 가격조정 제한</label>
                </div>
            </div>

            {/* 쿠폰율에 따른 경쟁제한 */}
            <div className="mb-3" style={{ marginLeft: '40px' }}>
                <div className="input-group" style={{ width: '200px' }}>
                    <input
                        type="number"
                        step="0.01"
                        className="form-control"
                        {...register('skip_low_coupon.value', { valueAsNumber: true })}
                    />
                    <span className="input-group-text">%</span>
                </div>
                <div className="form-text">쿠폰율이 설정된 퍼센트 미만인 경우 가격 경쟁 제외</div>
            </div>

            {/* 변동폭 제한: 가격 경쟁 시 */}
            <div className="d-flex gap-3">
                <div className="form-check form-switch">
                    <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        {...register('adjust_max_step.is_enabled')}
                    />
                    <label className="form-label">가격 경쟁 시 변동폭 제한</label>
                    <span
                        className="ms-1 text-muted"
                        title="맞춤 전략에는 변동폭 제한이 적용되지 않습니다."
                        aria-label="맞춤 전략에는 변동폭 제한이 적용되지 않습니다."
                        tabIndex={0}
                    >
                        <CircleAlert size={15} />
                    </span>
                </div>
            </div>
            <div className="mb-3" style={{ marginLeft: '40px' }}>
                <div className="input-group" style={{ width: '200px' }}>
                    <input
                        type="number"
                        step="0.01"
                        className="form-control"
                        min={0}
                        {...register('adjust_max_step.value', { valueAsNumber: true })}
                    />
                    <span className="input-group-text">%</span>
                </div>
            </div>

            {/* 변동폭 제한: 가격 복구 시 */}
            <div className="d-flex gap-3">
                <div className="form-check form-switch">
                    <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        {...register('reset_max_step.is_enabled')}
                    />
                    <label className="form-label">가격 복구 시 변동폭 제한</label>
                </div>
            </div>
            <div className="mb-3" style={{ marginLeft: '40px' }}>
                <div className="input-group" style={{ width: '200px' }}>
                    <input
                        type="number"
                        step="0.01"
                        className="form-control"
                        {...register('reset_max_step.value', { valueAsNumber: true })}
                    />
                    <span className="input-group-text">%</span>
                </div>
            </div>

            {/* 하한가 가격 복구 */}
            <div className="d-flex gap-3 mb-3">
                <div className="d-flex gap-3">
                    <div className="form-check form-switch">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            {...register('reset_on_ll.is_enabled')}
                        />
                        <label className="form-label">하한가 도달 시 기본가격으로 복구</label>
                    </div>
                </div>
            </div>

            {/* 하한가 가격 복구: 경쟁 대기 */}
            <div className="d-flex gap-3">
                <div className="form-check form-switch">
                    <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        {...register('reset_on_ll_countime.is_enabled')}
                    />
                    <label className="form-label">하한가 도달 시 기본가격으로 복구 후 경쟁 대기</label>
                </div>
            </div>
            <div className="d-flex mb-3" style={{ marginLeft: '40px' }}>
                <div className="input-group" style={{ width: '200px' }}>
                    <input
                        type="number"
                        step="5"
                        className="form-control"
                        {...register('reset_on_ll_countime.value', { valueAsNumber: true })}
                    />
                    <span className="input-group-text">분</span>
                </div>
            </div>
            <div className="d-flex gap-3 mb-3">
                <div className="form-check form-switch">
                    <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        {...register('should_recover_price_on_active_schedule')}
                    />
                    <label className="form-label">스케줄 복구가 활성화시 즉시복구/경쟁배제</label>
                </div>
            </div>
        </div>
    );
};

export default UserAdjustConfigFields;
